import React from "react";
import { ContentPanel } from "components/displays";
import {
  ListBuilder,
  Table,
  ActionBar,
  ModalBuilder,
  Modal,
} from "@redriver/cinnamon";
import { TablePagination } from "components/pagination";
import {
  dateFormatter,
  blankDataFormatter,
  yesNoFormatter,
} from "components/displays/DisplayHelper";
import { withPermissions } from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { Button } from "semantic-ui-react";
import FileSaver from "file-saver";

const AdditionalDocumentTable = ({
  dealerId,
  loadAction,
  emptyMessage,
  AddModal,
  approveAction,
  downloadAction,
  hasPermission,
}) => {
  const canApprove = hasPermission(
    Targets.AdditionalDocuments,
    Actions.Approve,
  );
  const canDownload = hasPermission(
    Targets.AdditionalDocuments,
    Actions.Download,
  );

  return (
    <ContentPanel
      wrapperCssClass="outline-grid dealers-details"
      headerCssClass="defaults-page-title"
    >
      <div className="additional-doc-container">
        <ListBuilder
          withTable
          loadAction={() => loadAction(dealerId)}
          renderList={(tableProps, state, events) => (
            <React.Fragment>
              <ActionBar>
                <ActionBar.Item>
                  <AddModal
                    dealerId={dealerId}
                    onSubmitted={events.onRefresh}
                  />
                </ActionBar.Item>
              </ActionBar>
              <Table
                {...tableProps}
                compact
                selectable
                dataKey="id"
                emptyMessage={emptyMessage}
              >
                <Table.Column
                  field="reference"
                  title="Reference"
                  width="20%"
                  header="Reference"
                />
                <Table.Column
                  field="uploadedDate"
                  title="Uploaded Date"
                  width="10%"
                  header="Uploaded Date"
                  render={(item) =>
                    blankDataFormatter(dateFormatter(item.uploadedDate), "-")
                  }
                />
                <Table.Column
                  field="uploadedBy"
                  title="Uploaded By"
                  width="10%"
                  header="Uploaded By"
                  render={(item) => blankDataFormatter(item.uploadedBy, "-")}
                />
                <Table.Column
                  field="approvedBy1"
                  title="First Approver"
                  width="10%"
                  header="First Approver"
                  render={(item) => blankDataFormatter(item.approvedBy1, "-")}
                />
                <Table.Column
                  field="approvedBy1Utc"
                  title="First Approver Date"
                  width="10%"
                  header="First Approver Date"
                  render={(item) =>
                    blankDataFormatter(dateFormatter(item.approvedBy1Utc), "-")
                  }
                />
                <Table.Column
                  field="approvedBy2"
                  title="Second Approver"
                  width="10%"
                  header="Second Approver"
                  render={(item) => blankDataFormatter(item.approvedBy2, "-")}
                />
                <Table.Column
                  field="approvedBy2Utc"
                  title="Second Approver Date"
                  width="10%"
                  header="Second Approver Date"
                  render={(item) =>
                    blankDataFormatter(dateFormatter(item.approvedBy2Utc), "-")
                  }
                />
                <Table.Column
                  field="isLive"
                  title="Live"
                  width="5%"
                  header="Live"
                  render={(item) => yesNoFormatter(item.isLive)}
                />
                {(canApprove || canDownload) && (
                  <Table.Column
                    field="id"
                    width="5%"
                    render={(item) => (
                      <Button.Group basic size="medium">
                        {canApprove && approveAction && (
                          <ApproveDocument
                            fileName={item.fileName}
                            id={item.id}
                            reloadTable={events.onRefresh}
                            approveAction={approveAction}
                            disabled={!item.requiresApproval}
                          />
                        )}
                        {canDownload && downloadAction && (
                          <DownloadDocument
                            item={item}
                            downloadAction={downloadAction}
                          />
                        )}
                      </Button.Group>
                    )}
                  />
                )}
              </Table>
              <TablePagination
                pageNumber={state.pagination.pageNumber}
                onChange={events.onChangePagination}
                pageSize={state.pagination.pageSize}
                totalItems={state.total}
              />
            </React.Fragment>
          )}
        />
      </div>
    </ContentPanel>
  );
};

const ApproveDocument = ({
  fileName,
  disabled,
  id,
  reloadTable,
  approveAction,
}) => (
  <ModalBuilder
    submitAction={approveAction}
    submitParams={{ id }}
    onSubmitted={() => reloadTable()}
    renderTrigger={(showModal) => (
      <Button
        title="Approve"
        primary
        onClick={showModal}
        icon="check"
        disabled={disabled}
      />
    )}
    renderModal={(modalProps) => (
      <Modal.Confirmation {...modalProps} header="Approve">
        Are you sure you wish to approve {fileName}?
      </Modal.Confirmation>
    )}
  />
);

const DownloadDocument = ({ item, downloadAction }) => (
  <ModalBuilder
    submitAction={downloadAction}
    submitParams={{ id: item.id }}
    onSubmitted={(result) => {
      result && FileSaver.saveAs(result, `${item.fileName}`);
    }}
    renderTrigger={(showModal) => (
      <Button
        primary
        onClick={showModal}
        title="Download"
        icon="download"
        className="download-btn"
      />
    )}
    renderModal={(modalProps) => (
      <Modal.Confirmation {...modalProps} header="Download File">
        Are you sure you want to download?
      </Modal.Confirmation>
    )}
  />
);

export default withPermissions(AdditionalDocumentTable);
